module.exports = __webpack_public_path__ + "static/media/tastemakers-campus-6.fc56122b.png";